import { FC } from 'react';
import { Skeleton } from 'antd';
import { Container } from './CategoryMenu.style';
const CategoryMenuSkeleton: FC = () => {
  return <Container>
            <span>•</span>
            <Skeleton.Input active />
        </Container>;
};
export default CategoryMenuSkeleton;